import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface PillarCardProps {
  title: string;
  description: string;
  path: string;
  color: 'magenta' | 'cyan' | 'lime' | 'orange';
  icon?: React.ReactNode;
}
export function PillarCard({
  title,
  description,
  path,
  color,
  icon
}: PillarCardProps) {
  const colorStyles = {
    magenta: {
      border: 'border-brand-magenta',
      bg: 'bg-brand-magenta',
      text: 'text-brand-magenta'
    },
    cyan: {
      border: 'border-brand-cyan',
      bg: 'bg-brand-cyan',
      text: 'text-brand-cyan'
    },
    lime: {
      border: 'border-brand-lime',
      bg: 'bg-brand-lime',
      text: 'text-brand-lime'
    },
    orange: {
      border: 'border-brand-orange',
      bg: 'bg-brand-orange',
      text: 'text-brand-orange'
    }
  };
  const selected = colorStyles[color];
  return <Link to={path} className="block h-full" data-id="element-137">
      <motion.div whileHover={{
      y: -8
    }} className={`h-full border-2 border-brand-black bg-white p-8 flex flex-col relative overflow-hidden group`} data-id="element-138">
        {/* Top accent bar */}
        <div className={`absolute top-0 left-0 right-0 h-2 ${selected.bg}`} data-id="element-139" />

        <div className="mb-6" data-id="element-140">{icon}</div>

        <h3 className={`text-2xl font-black uppercase mb-4 group-hover:${selected.text} transition-colors`} data-id="element-141">
          {title}
        </h3>

        <p className="text-gray-600 mb-8 flex-grow leading-relaxed" data-id="element-142">
          {description}
        </p>

        <div className={`flex items-center font-bold text-sm uppercase tracking-wider ${selected.text}`} data-id="element-143">
          Explore Pillar{' '}
          <ArrowRight className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-144" />
        </div>
      </motion.div>
    </Link>;
}